import React from 'react'
import './ContactUs.css'


class ContactUs extends React.Component {
    constructor() {
        super();
        this.state = {
        }
    }

    render() {
        return (
            <div id="contactUsMainContainer">
                <div className='container bigBodyContainer'>
                    <div className="contact-header">
                        <h1 className="contact-title">Visit Us</h1>
                        <p className="contact-subtitle">Find our locations and get in touch</p>
                    </div>

                    <div id="contactUsContainer" className="contact-content">
                        <div className="locations-section">
                            <div className="location-card">
                                <div className="location-header">
                                    <h3 className="location-title">Kfarhazir Location</h3>
                                    <p className="location-address">Al-koura Beirut-Arz Main-Road</p>
                                </div>
                                <div className="map-container">
                                    <iframe
                                        width={window.innerWidth < 767 ? window.innerWidth - 100 : "100%"}
                                        height="300"
                                        title="WayCup Kfarhazir Location"
                                        className="location-map"
                                        src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d823.845525104877!2d35.76589032914602!3d34.31528722383234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2slb!4v1749320850234!5m2!1sen!2slb">
                                    </iframe>
                                </div>
                            </div>

                            <div className="location-card">
                                <div className="location-header">
                                    <h3 className="location-title">Batroun Location</h3>
                                    <p className="location-address">Souk Main-Road</p>
                                </div>
                                <div className="map-container">
                                    <iframe
                                        width={window.innerWidth < 767 ? window.innerWidth - 100 : "100%"}
                                        height="300"
                                        title="WayCup Batroun Location"
                                        className="location-map"
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d206.11252408617247!2d35.660114692816435!3d34.253636849926785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151f59001b81c857%3A0x12aac86949640c4f!2sWay%20Cup!5e0!3m2!1sen!2slb!4v1749321091359!5m2!1sen!2slb">
                                    </iframe>
                                </div>
                            </div>
                        </div>

                        <div className="contact-info-section">
                            <div className="contact-info-card">
                                <h3 className="info-title">Get In Touch</h3>
                                <div className="contact-methods">
                                    <div className="contact-method">
                                        <div className="contact-icon">📞</div>
                                        <div className="contact-details">
                                            <h4 className="method-title">Phone</h4>
                                            <a href="tel:+96170415225" className="contact-link">+961 70 415 225</a>
                                        </div>
                                    </div>
                                    <div className="contact-method">
                                        <div className="contact-icon">✉️</div>
                                        <div className="contact-details">
                                            <h4 className="method-title">Email</h4>
                                            <a href="mailto:info@waycup-lb.com" className="contact-link">info@waycup-lb.com</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ContactUs;